export default {
    SET_EQUIPMENT_WARRANTY(state, equipments) {
        state.equipments = equipments;
    }
}